// extracted by mini-css-extract-plugin
module.exports = {"title":"AddDocumentModal_title__3uBKJ","extra_form_wrapper":"AddDocumentModal_extra_form_wrapper__1AY8J","form_item":"AddDocumentModal_form_item__3dVs3"};